import { all } from "redux-saga/effects";
import { combineReducers } from "redux";
import { payCodeReducer } from "./reducers";

import * as auth from "../app/modules/Auth/_redux/authRedux";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  payCode: payCodeReducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
